import * as Yup from 'yup';

import { Actions, SignerFile } from './index';

export type ExampleFields = {
  fields: string[],
}

export type BulkSendInitFormData = {
  lockedTitle?: string | null,
  lockedMessage?: string | null,
}

export type BulkSendInitResponse = {
  signerKey: string,
  isCcEnabled: boolean,
  form?: BulkSendInitFormData,
}

export type BulkSendData = {
  exampleFields: string[],
  signerFile: SignerFile | null,
}

export const bulkSendDataSchema = Yup.object<BulkSendData>({
  exampleFields: Yup.array().of(Yup.string()).ensure(),
  signerFile: Yup.object<SignerFile>().nullable().default(null),
});

export type ValidateBulkSendRequest = {
  signerKey: string,
  signerFile: {
    tmpName: string,
  },
  templateIds: string[],
}

export interface SetBulkSendData {
  type: Actions.SetBulkSendData,
  payload: Partial<BulkSendData>,
}

export type BulkSendActions =
  | SetBulkSendData;
